var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"state":_vm.state,"invalid-feedback":_vm.message}},[_vm._t("label",[_c('label',{ref:"label",class:_vm.labelClass,attrs:{"state":_vm.state}},[_vm._v(_vm._s(_vm.label))])]),_vm._t("addon"),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }